export default __webpack_public_path__ + "static/media/icon--fee01.859dcf7b.svg";